import { handleActions, createAction } from 'redux-actions';
import { cloneDeep } from 'lodash';

import { NEW_BETS, MY_BETS, LOST_AUCTIONS } from '../consts/navigation';

// New Bets
export const FETCH_NEW_BETS = createAction('FETCH/NEW/BETS');
export const FETCH_NEW_BETS_SUCCESS = createAction('FETCH/NEW/BETS/SUCCESS');
export const FETCH_NEW_BETS_FAIL = createAction('FETCH/NEW/BETS/FAIL');

// My Bets
export const FETCH_MY_BETS = createAction('FETCH/MY/BETS');
export const FETCH_MY_BETS_SUCCESS = createAction('FETCH/MY/BETS/SUCCESS');
export const FETCH_MY_BETS_FAIL = createAction('FETCH/MY/BETS/FAIL');

const initialState = {
  recentNewBets: false,
  [NEW_BETS]: {
    data: [],
    errors: null,
    total_count: null,
    total_pages: null,
  },
  [MY_BETS]: {
    data: [],
    errors: null,
    total_count: null,
    total_pages: null,
  },
  [LOST_AUCTIONS]: {
    data: [],
    errors: null,
    total_count: null,
    total_pages: null,
  },
};

const betsTablesReducer = handleActions(
  {
    [FETCH_NEW_BETS_SUCCESS]: (state, { payload: { bets, recent_new_bets, total_count, total_pages, }, }) => {
      const newState = cloneDeep(state);
      newState[NEW_BETS].data = bets;
      newState[NEW_BETS].total_count = total_count;
      newState[NEW_BETS].total_pages = total_pages;
      newState.recentNewBets = recent_new_bets;
      return newState;
    },
    [FETCH_NEW_BETS_FAIL]: (state, { payload: { error, }, }) => {
      const newState = cloneDeep(state);
      newState[NEW_BETS].errors = error;
      return newState;
    },
    [FETCH_MY_BETS_SUCCESS]: (state, { payload: { bets, recent_new_bets, total_count, total_pages, }, }) => {
      const newState = cloneDeep(state);
      newState[MY_BETS].data = bets;
      newState[MY_BETS].total_count = total_count;
      newState[MY_BETS].total_pages = total_pages;
      newState.recentNewBets = recent_new_bets;
      return newState;
    },
    [FETCH_MY_BETS_FAIL]: (state, { payload: { error, }, }) => {
      const newState = cloneDeep(state);
      newState[MY_BETS].errors = error;
      return newState;
    },
  },
  initialState
);

export default betsTablesReducer;
